import React from 'react';
import { withStyles,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  IconButton,
  Fade,
  Slide } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Settings from '@material-ui/icons/Settings';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import DateRange from '@material-ui/icons/DateRange';
import Group from '@material-ui/icons/Group';
import Cached from '@material-ui/icons/Cached';
import SwapVert from '@material-ui/icons/SwapVert';
import Assignment from '@material-ui/icons/Assignment';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});
@inject('usuarioStore')
@observer
class TabelasApoioPrincipal extends React.Component {
  render () {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Link to='/dashboard' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Tabelas de Apoio</Typography>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <List>
            <Divider />
            <Link to={'/tabelasApoio/parametros'} className={classes.link}>
              <Fade timeout={600} in>
                <ListItem button key='0'>
                  <Settings />
                  <ListItemText
                    primary='Parâmetros do Sistema'
                    secondary='Manutenção dos parâmetros do sistema' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/faixaRemuneracao'} className={classes.link}>
              <Fade timeout={1000} in>
                <ListItem button key='1'>
                  <MonetizationOn />
                  <ListItemText
                    primary='Faixas de Remuneração'
                    secondary='Cadastro de faixas de remuneração' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/faixaEtaria'} className={classes.link}>
              <Fade timeout={1400} in>
                <ListItem button key='2'>
                  <DateRange />
                  <ListItemText
                    primary='Faixas Etárias'
                    secondary='Cadastro de faixas etárias' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/tipoMensalidade'} className={classes.link}>
              <Fade timeout={1800} in>
                <ListItem button key='3'>
                  <Group />
                  <ListItemText
                    primary='Tipos de Mensalidades'
                    secondary='Cadastro de tipos de mensalidades' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/mensalidade'} className={classes.link}>
              <Fade timeout={2200} in>
                <ListItem button key='3'>
                  <Cached />
                  <ListItemText
                    primary='Mensalidades, Valores e Reajustes'
                    secondary='Cadastro de mensalidades, valores e reajustes.' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/limiteCobranca'} className={classes.link}>
              <Fade timeout={2600} in>
                <ListItem button key='4'>
                  <SwapVert />
                  <ListItemText
                    primary='Limite de Cobrança de Coparticipação'
                    secondary='Cadastro de limites de cobrança de coparticipação em relação à remuneração.' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/tabelasApoio/vigenciaPorte'} className={classes.link}>
              <Fade timeout={3000} in>
                <ListItem button key='5'>
                  <Assignment />
                  <ListItemText
                    primary='Vigências de Porte Anestésico'
                    secondary='Cadastro de Vigências de Porte Anestésico.' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(TabelasApoioPrincipal);
